module.exports = __webpack_public_path__ + "static/media/advanced-audiology.cc789b4e.png";